import type { Address as ShopifyAddress } from "@shopify/address";
import AddressFormatter from "@shopify/address";

import type { OrderQuery } from "~/graphql/graphql-new.gen";

export const countries = [
  {
    code: "AF",
  },
  {
    code: "ZA",
  },
  {
    code: "AX",
  },
  {
    code: "AL",
  },
  {
    code: "DZ",
  },
  {
    code: "DE",
  },
  {
    code: "AD",
  },
  {
    code: "AO",
  },
  {
    code: "AI",
  },
  {
    code: "AQ",
  },
  {
    code: "AG",
  },
  {
    code: "SA",
  },
  {
    code: "AR",
  },
  {
    code: "AM",
  },
  {
    code: "AW",
  },
  {
    code: "AU",
  },
  {
    code: "AT",
  },
  {
    code: "AZ",
  },
  {
    code: "BS",
  },
  {
    code: "BH",
  },
  {
    code: "BD",
  },
  {
    code: "BB",
  },
  {
    code: "BY",
  },
  {
    code: "BE",
  },
  {
    code: "BZ",
  },
  {
    code: "BJ",
  },
  {
    code: "BM",
  },
  {
    code: "BT",
  },
  {
    code: "BO",
  },
  {
    code: "BQ",
  },
  {
    code: "BA",
  },
  {
    code: "BW",
  },
  {
    code: "BV",
  },
  {
    code: "BR",
  },
  {
    code: "BN",
  },
  {
    code: "BG",
  },
  {
    code: "BF",
  },
  {
    code: "BI",
  },
  {
    code: "KY",
  },
  {
    code: "KH",
  },
  {
    code: "CM",
  },
  {
    code: "CA",
  },
  {
    code: "CV",
  },
  {
    code: "CF",
  },
  {
    code: "CL",
  },
  {
    code: "CN",
  },
  {
    code: "CX",
  },
  {
    code: "CY",
  },
  {
    code: "CC",
  },
  {
    code: "CO",
  },
  {
    code: "KM",
  },
  {
    code: "CG",
  },
  {
    code: "CD",
  },
  {
    code: "CK",
  },
  {
    code: "KR",
  },
  {
    code: "KP",
  },
  {
    code: "CR",
  },
  {
    code: "CI",
  },
  {
    code: "HR",
  },
  {
    code: "CU",
  },
  {
    code: "CW",
  },
  {
    code: "DK",
  },
  {
    code: "DJ",
  },
  {
    code: "DO",
  },
  {
    code: "DM",
  },
  {
    code: "EG",
  },
  {
    code: "SV",
  },
  {
    code: "AE",
  },
  {
    code: "EC",
  },
  {
    code: "ER",
  },
  {
    code: "ES",
  },
  {
    code: "EE",
  },
  {
    code: "US",
  },
  {
    code: "ET",
  },
  {
    code: "FK",
  },
  {
    code: "FO",
  },
  {
    code: "FJ",
  },
  {
    code: "FI",
  },
  {
    code: "FR",
  },
  {
    code: "GA",
  },
  {
    code: "GM",
  },
  {
    code: "GE",
  },
  {
    code: "GS",
  },
  {
    code: "GH",
  },
  {
    code: "GI",
  },
  {
    code: "GR",
  },
  {
    code: "GD",
  },
  {
    code: "GL",
  },
  {
    code: "GP",
  },
  {
    code: "GU",
  },
  {
    code: "GT",
  },
  {
    code: "GG",
  },
  {
    code: "GN",
  },
  {
    code: "GW",
  },
  {
    code: "GQ",
  },
  {
    code: "GY",
  },
  {
    code: "GF",
  },
  {
    code: "HT",
  },
  {
    code: "HM",
  },
  {
    code: "HN",
  },
  {
    code: "HK",
  },
  {
    code: "HU",
  },
  {
    code: "IM",
  },
  {
    code: "UM",
  },
  {
    code: "VG",
  },
  {
    code: "VI",
  },
  {
    code: "IN",
  },
  {
    code: "ID",
  },
  {
    code: "IR",
  },
  {
    code: "IQ",
  },
  {
    code: "IE",
  },
  {
    code: "IS",
  },
  {
    code: "IL",
  },
  {
    code: "IT",
  },
  {
    code: "JM",
  },
  {
    code: "JP",
  },
  {
    code: "JE",
  },
  {
    code: "JO",
  },
  {
    code: "KZ",
  },
  {
    code: "KE",
  },
  {
    code: "KG",
  },
  {
    code: "KI",
  },
  {
    code: "KW",
  },
  {
    code: "LA",
  },
  {
    code: "LS",
  },
  {
    code: "LV",
  },
  {
    code: "LB",
  },
  {
    code: "LR",
  },
  {
    code: "LY",
  },
  {
    code: "LI",
  },
  {
    code: "LT",
  },
  {
    code: "LU",
  },
  {
    code: "MO",
  },
  {
    code: "MK",
  },
  {
    code: "MG",
  },
  {
    code: "MY",
  },
  {
    code: "MW",
  },
  {
    code: "MV",
  },
  {
    code: "ML",
  },
  {
    code: "MT",
  },
  {
    code: "MP",
  },
  {
    code: "MA",
  },
  {
    code: "MH",
  },
  {
    code: "MQ",
  },
  {
    code: "MU",
  },
  {
    code: "MR",
  },
  {
    code: "YT",
  },
  {
    code: "MX",
  },
  {
    code: "FM",
  },
  {
    code: "MD",
  },
  {
    code: "MC",
  },
  {
    code: "MN",
  },
  {
    code: "ME",
  },
  {
    code: "MS",
  },
  {
    code: "MZ",
  },
  {
    code: "MM",
  },
  {
    code: "NA",
  },
  {
    code: "NR",
  },
  {
    code: "NP",
  },
  {
    code: "NI",
  },
  {
    code: "NE",
  },
  {
    code: "NG",
  },
  {
    code: "NU",
  },
  {
    code: "NF",
  },
  {
    code: "NO",
  },
  {
    code: "NC",
  },
  {
    code: "NZ",
  },
  {
    code: "IO",
  },
  {
    code: "OM",
  },
  {
    code: "UG",
  },
  {
    code: "UZ",
  },
  {
    code: "PK",
  },
  {
    code: "PW",
  },
  {
    code: "PS",
  },
  {
    code: "PA",
  },
  {
    code: "PG",
  },
  {
    code: "PY",
  },
  {
    code: "NL",
  },
  {
    code: "PE",
  },
  {
    code: "PH",
  },
  {
    code: "PN",
  },
  {
    code: "PL",
  },
  {
    code: "PF",
  },
  {
    code: "PR",
  },
  {
    code: "PT",
  },
  {
    code: "QA",
  },
  {
    code: "RE",
  },
  {
    code: "RO",
  },
  {
    code: "GB",
  },
  {
    code: "RU",
  },
  {
    code: "RW",
  },
  {
    code: "EH",
  },
  {
    code: "BL",
  },
  {
    code: "KN",
  },
  {
    code: "SM",
  },
  {
    code: "MF",
  },
  {
    code: "SX",
  },
  {
    code: "PM",
  },
  {
    code: "VA",
  },
  {
    code: "VC",
  },
  {
    code: "SH",
  },
  {
    code: "LC",
  },
  {
    code: "SB",
  },
  {
    code: "WS",
  },
  {
    code: "AS",
  },
  {
    code: "ST",
  },
  {
    code: "SN",
  },
  {
    code: "RS",
  },
  {
    code: "SC",
  },
  {
    code: "SL",
  },
  {
    code: "SG",
  },
  {
    code: "SK",
  },
  {
    code: "SI",
  },
  {
    code: "SO",
  },
  {
    code: "SD",
  },
  {
    code: "SS",
  },
  {
    code: "LK",
  },
  {
    code: "SE",
  },
  {
    code: "CH",
  },
  {
    code: "SR",
  },
  {
    code: "SJ",
  },
  {
    code: "SZ",
  },
  {
    code: "SY",
  },
  {
    code: "TJ",
  },
  {
    code: "TW",
  },
  {
    code: "TZ",
  },
  {
    code: "TD",
  },
  {
    code: "CZ",
  },
  {
    code: "TF",
  },
  {
    code: "TH",
  },
  {
    code: "TL",
  },
  {
    code: "TG",
  },
  {
    code: "TK",
  },
  {
    code: "TO",
  },
  {
    code: "TT",
  },
  {
    code: "TN",
  },
  {
    code: "TM",
  },
  {
    code: "TC",
  },
  {
    code: "TR",
  },
  {
    code: "TV",
  },
  {
    code: "UA",
  },
  {
    code: "UY",
  },
  {
    code: "VU",
  },
  {
    code: "VE",
  },
  {
    code: "VN",
  },
  {
    code: "WF",
  },
  {
    code: "YE",
  },
  {
    code: "ZM",
  },
  {
    code: "ZW",
  },
];

export interface Address {
  name?: string;
  street: string;
  street2?: string;
  city: string;
  bp: string;
  province?: string;
  country: string;
  countryCode: string;
}

export const getFormattedAddress = async (
  address: ShopifyAddress,
  locale: string,
) => {
  const addressFormatter = new AddressFormatter(locale);
  const formattedAddress = await addressFormatter.format(address);
  return formattedAddress.filter((f) => f !== "");
};

export const formatCountryName = (countryCode: string, locale: string) => {
  const regionNames = new Intl.DisplayNames([locale], {
    type: "region",
  });
  return regionNames.of(countryCode) ?? "";
};

export const recipientToAddress = (
  recipient:
    | OrderQuery["order"]["recipient"]
    | NonNullable<OrderQuery["order"]["recipient"]["previous"]>,
): Address => {
  return {
    name: recipient.fullName,
    street: recipient.address.street,
    street2: recipient.address.streetAdditional ?? undefined,
    city: recipient.address.city,
    province: recipient.address.state ?? undefined,
    bp: recipient.address.zipCode,
    country: recipient.address.country,
    countryCode: recipient.address.countryCode,
  };
};

export const recipientToShopifyAddress = (
  recipient:
    | OrderQuery["order"]["recipient"]
    | NonNullable<OrderQuery["order"]["recipient"]["previous"]>,
): ShopifyAddress => {
  return {
    firstName: recipient.firstName,
    lastName: recipient.lastName,
    address1: recipient.address.street,
    address2: recipient.address.streetAdditional ?? "",
    city: recipient.address.city,
    province: recipient.address.state ?? undefined,
    zip: recipient.address.zipCode,
    country: recipient.address.countryCode ?? "FR",
  };
};
